<!-- 数据窗口配置 -->
<template>
<div>
  <m-table
    ref="table"
    :filterObj='{
      ID:$route.query.ID,
    }'
    :colObj='{
      opId:5,
    }'
  >
  </m-table>
  <el-dialog :visible.sync="dialog" :append-to-body="true" width="90%" top="1vh" :title="select.searchslottitle" @closed="dialogS=false;" :close-on-click-modal="false" v-dialogdrag>
    <Selector v-if="dialogS" ref="ConSelector" :select="select" @listenEvent="fn"></Selector>
  </el-dialog>
</div>
</template>
<script>
import Selector from '@/components/table/selectorc';
import {processDeal} from '@/api/home/home';
import {flushDwid} from '@/api/table/table';
import {mapGetters} from "vuex";
  export default {
    components: {
      Selector,
    },
    data() {
      return {
        firstEnter:false,
        dialog:false,
        dialogS:false,
        select:{
          searchslottitle:"请选择数据实体",
          searchslotId:102,
          searchslotkey:{ID:"ID",TABLE_COMMENTS:"TABLE_COMMENTS"},
          multiple:false,
        }
      };
    },
    computed: {
      ...mapGetters(['userInfo'])
    },
    created(){},
    methods: {
      // 查看表头内容
      fieldBtnRowClick(btn,row){
        this.$router.push({
          path:"/table/keySetup",
          query:{
            runId:this.$route.query.runId,
            id:row.ID,
            sname:row.DW_NAME,
          }
        })
      },
      //   查看按钮设计
      tableBtnRowClick(btn,row){
        this.$router.push({
          path:"/table/buttonSetup",
          query:{
            runId:this.$route.query.runId,
            id:row.ID,
          }
        })
      },
      // 新增
      addBtnClick(btn,row){
        this.dialogS=true;
        this.dialog=true;
      },
      // 获取选择器数据
      fn(param){
        console.log(param);
        this.dialog=false;
        if(!param||param.ID.length===0) return;
        this.$confirm(`确定新增[${param.TABLE_COMMENTS}]数据视图吗?`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal:false,
        }).then(() => {
          processDeal({obj:JSON.stringify({id:6,tableid:param.ID.toString()})}).then(res=>{
            this.$refs.table.$refs.child.onLoad();
            this.$message.success("新增成功!");
          },err=>{})
        })
      },
      // 刷新数据实体和数据窗口
      refreshBtnRowClick(btn,row){
        this.$confirm(`确定刷新 [${row.DW_NAME}] 的数据实体和数据窗口吗?`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal:false,
        }).then(() => {
          flushDwid(this.$qs.stringify({dwid:row.ID,runId:this.$route.query.runId})).then(res=>{
            this.$refs.table.$refs.child.onLoad();
            this.$message.success("刷新成功!");
          },err=>{})
        })
      },
      // 复制按钮
      copyRowClick(btn,row){
        processDeal({obj:JSON.stringify({id:13,userid:this.userInfo.user_id,dwid:row.ID})}).then(res=>{
          this.$refs.table.$refs.child.onLoad();
          this.$message.success("复制成功!");
        },err=>{})
      },
      // 删除按钮
      deleteRowClick(btn,row){
        processDeal({obj:JSON.stringify({id:14,dwid:row.ID})}).then(res=>{
          this.$refs.table.$refs.child.onLoad();
          this.$message.success("删除成功!");
        },err=>{})
      },
    },
    activated(){
      if(this.firstEnter){
        this.firstEnter=false;
      }else{
        this.$refs.table.$refs.child.onLoad();
      }
    }
  };
</script>

<style lang='scss' scoped>
</style>
